<template>
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1.5L2.04936 1.70987C2.91136 1.88227 3.55973 2.59732 3.6472 3.47203L3.8 5M3.8 5L4.7886 13.2383C4.90922 14.2435 5.76195 15 6.77435 15H15.7673C17.3733 15 18.7733 13.907 19.1628 12.3489L20.2855 7.85783C20.6485 6.40619 19.5505 5 18.0542 5H3.8Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M12 12H8"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="7.5" cy="18.5" r="1.5" :fill="color" />
    <circle cx="16.5" cy="18.5" r="1.5" :fill="color" />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  color: {
    type: String,
    default: "black",
  },
});
</script>
